module.exports = {
    getUrl: Odigeo._.constant('getsubscriptiondetails'),

    getMethod: Odigeo._.constant('GET'),

    requestSuccess: function(data) {
        Odigeo.trigger(this.widget.id + ':getSubscriptionDetailsOk', data);
    },

    requestError: Odigeo._.noop(),
};
